import { createPaginator } from "@smithy/core";
import { GetTextDetectionCommand, } from "../commands/GetTextDetectionCommand";
import { RekognitionClient } from "../RekognitionClient";
export const paginateGetTextDetection = createPaginator(RekognitionClient, GetTextDetectionCommand, "NextToken", "NextToken", "MaxResults");
